import { Suspense, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import useReveal from './useReveal';
import './Public.css';

// Shell for every public page: navbar, page content, footer.
export default function PublicLayout() {
  const { hash, pathname } = useLocation();

  // Jump to #section links (e.g. /terms#refunds) once the page has rendered.
  useEffect(() => {
    if (!hash) return;
    const t = setTimeout(() => document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: 'smooth' }), 150);
    return () => clearTimeout(t);
  }, [hash, pathname]);

  return (
    <>
      <Navbar />
      <main>
        <Suspense fallback={<div className="page-loader" role="status" aria-label="Loading"><span className="spinner spinner--dark" /></div>}>
          <Outlet />
        </Suspense>
      </main>
      <Footer />
    </>
  );
}

// Wraps each page: sets the tab title and animates `.reveal` blocks once mounted.
export function Page({ title, children }) {
  useReveal();
  useEffect(() => {
    document.title = title ? `${title} | PinParcels` : 'PinParcels | Send items with travellers on your route';
  }, [title]);
  return children;
}

export function PageHero({ kicker, title, text, children, align = 'center' }) {
  return (
    <section className={`page-hero page-hero--${align}`}>
      <div className="page-hero__bg" aria-hidden="true" />
      <div className="container page-hero__inner reveal">
        {kicker && <span className="kicker">{kicker}</span>}
        <h1>{title}</h1>
        {text && <p className="lead">{text}</p>}
        {children}
      </div>
    </section>
  );
}
